import React, { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './index.module.scss';
import { useGetNotificationSettings } from 'src/models/users/NotificationSettings/hooks';
import NotificationSettings from './NotificationSettingsItem';
import { NotificationGroupName } from 'src/models/notifications/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-light-svg-icons';
import { Skeleton, PageHeading } from 'src/common';
import { NOTIFICATIONS_SETTINGS_ICON_MAPPER } from 'src/models/users/NotificationSettings/mappers';
import { useLoadAllMps } from 'src/models/matchingProfiles/hooks';
import { InfoLabel } from 'src/shared';

export const NotificationSetting: FC = () => {
  const { t } = useTranslation();
  const { data: groups, loading: settingsLoading } = useGetNotificationSettings();
  const { loading: mpsLoading } = useLoadAllMps();
  const loading = settingsLoading || mpsLoading;

  return (
    <>
      <PageHeading
        title={t('Navigation.Settings.notifications')}
        desc={t('Notifications.notificationSettingsDesc')}
        icon={faBell}
      />
      {loading ? (
        <Skeleton active loading />
      ) : (
        <ul className={styles.groups}>
          {!!groups.length &&
            groups.map(group => (
              <li className={styles.group} key={group.name}>
                <h3 className={styles.groupTitle}>
                  <FontAwesomeIcon
                    icon={NOTIFICATIONS_SETTINGS_ICON_MAPPER[group.name].defaultIcon}
                    color={NOTIFICATIONS_SETTINGS_ICON_MAPPER[group.name].color}
                    className={styles.groupIcon}
                  />
                  <InfoLabel
                    title={t(`Notifications.notificationSettingsName_${NotificationGroupName[group.name]}`)}
                    desc={
                      group.name === NotificationGroupName.WS_SENDOUT ? (
                        <Trans
                          i18nKey={'Notifications.workspaceNotificationsInfo'}
                          components={{ 1: <ul></ul>, 2: <li></li>, 3: <div className={styles.newLine}></div> }}
                        />
                      ) : undefined
                    }
                    className={styles.groupName}
                  />
                </h3>
                <ul className={styles.settings}>
                  {group.notificationSettings &&
                    group.notificationSettings.map(setting => (
                      <NotificationSettings setting={setting} key={setting.itemId || setting.name} />
                    ))}
                </ul>
              </li>
            ))}
        </ul>
      )}
    </>
  );
};

export default NotificationSetting;
